import { PAYMENT_METHOD } from "../../../constants/sharedConstans";
import { useState, useEffect } from "react";

// Helper function to format seconds into #H:#M
const formatTime = (totalSeconds) => {
  if (isNaN(totalSeconds) || totalSeconds < 0) {
    return "0h:0m";
  }
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);

  return `${hours}h:${minutes}m`;
};

const formatArrayJoinValue = (value, columnConfig) => {
  const separator = columnConfig?.separator ?? ", ";
  const property = columnConfig?.property ?? "name";

  if (!Array.isArray(value)) {
    return value;
  }

  return value
    .filter((v) => v !== null && v !== undefined)
    .map((v) => {
      if (typeof v === "object") {
        return String(v?.[property] ?? "");
      }
      return String(v);
    })
    .join(separator);
};

const TableCell = ({ value, columnConfig, item }) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    let intervalId;
    if (columnConfig.type === "timer" && value) {
      const calculateElapsedTime = () => {
        const startTime = new Date(value).getTime();
        const now = new Date().getTime();
        const differenceInSeconds = Math.max(
          0,
          Math.floor((now - startTime) / 1000)
        );
        setElapsedTime(differenceInSeconds);
      };

      calculateElapsedTime();
      intervalId = setInterval(calculateElapsedTime, 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [value, columnConfig.type]);

  const checkType = () => {
    if (columnConfig.type == "currency") {
      return <td> {"$" + new Intl.NumberFormat("es-CL").format(value)} </td>;
    } else if (columnConfig.type == "actions") {
      return (
        <td>
          {columnConfig.buttons.map((oneButton, index) => {
            return (
              <button
                type="button"
                className="btn btn-table btn-sm me-2"
                key={index}
                onClick={(e) => {
                  oneButton.action(item);
                  e.stopPropagation();
                }}
              >
                <i className={oneButton.iconClass}></i>
              </button>
            );
          })}
        </td>
      );
    } else if (columnConfig.type == "date") {
      let formatDay = new Date(value);
      return (
        <td>
          {`${formatDay.toLocaleDateString("es-CL")} ${formatDay.toLocaleTimeString("es-CL")}`}
        </td>
      );
    } else if (columnConfig.type == "shortDate") {
      let formatDay = new Date(value);
      return <td> {formatDay.toLocaleDateString("es-CL")} </td>;
    } else if (columnConfig.type == "paymentMethod") {
      return <td> {PAYMENT_METHOD[value].name}</td>;
    } else if (columnConfig.type == "map") {
      return (
        <td> {columnConfig.map.find((item) => item.id === value)?.name}</td>
      );
    } else if (columnConfig.type === "arrayJoin") {
      return <td> {formatArrayJoinValue(value, columnConfig)} </td>;
    } else if (columnConfig.type === "timer") {
      return <td>{formatTime(elapsedTime)}</td>;
    } else {
      return <td> {value} </td>;
    }
  };

  return checkType();
};

export default TableCell;
